<template>
  <a-popover
    placement="bottomRight"
    destroyPopupOnHide
    overlayClassName="xmov-popover-noarrow"
  >
    <span class="preview eye-icon" @click.stop="() => {}">
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-[16px] h-[16px]"
      >
        <path
          data-follow-stroke="#fff"
          d="M7.495 13.162a5.667 5.667 0 1 0 0-11.333 5.667 5.667 0 0 0 0 11.333Z"
          stroke="#fff"
          stroke-width="1.4"
          stroke-linejoin="round"
        />
        <path
          data-follow-stroke="#fff"
          d="M7.495 5.495v4M5.5 7.5l3.995-.005m2.075 4.075 1.828 1.828"
          stroke="#fff"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <template #content>
      <div class="p-[8px] w-[544px]">
        <GeneratedVideo
          v-if="isHaveVideo"
          :class="'block w-[528px] h-[298px]'"
          :type="data.vertical ? 'vertical' : 'landscape'"
          :data="data.lastGenerate"
        />
        <div
          v-else
          class="w-[528px] h-[298px] overflow-hidden rounded-tr-[10px] rounded-tl-[10px] bg-back-4"
        >
          <img
            loading="lazy"
            :class="[
              data.vertical ? 'object-contain' : 'object-cover',
              'w-full h-full align-middle',
            ]"
            :src="data.cover"
          />
        </div>
        <div class="mt-[16px] flex-y-center justify-between w-full gap-[10px]">
          <div class="flex-y-center gap-[6px] flex-1 truncate">
            <div class="text-16 font-semibold truncate text-font-1">
              {{ data.title }}
            </div>
            <TagStatus
              :status="
                data.lastGenerate?.preview_video_info?.render_video_status
              "
            />
          </div>
          <div class="text-font-40 text-12 flex-shrink-0">
            {{ data.time }}
          </div>
        </div>
        <div class="mt-[12px] flex-y-center">
          <div class="flex gap-[10px] flex-wrap flex-1">
            <span
              v-for="tag in data?.tags"
              :key="tag.label"
              class="text-12 text-primary min-w-[48px] h-[24px] flex-center px-[10px] rounded-[6px] bg-purple-1"
            >
              {{ tag.label }}
            </span>
          </div>
        </div>
        <div v-if="data.description" class="text-font-60 mt-[10px]">
          {{ data.description }}
        </div>
      </div>
    </template>
  </a-popover>
</template>

<script lang="ts" setup>
import GeneratedVideo from './generatedVideo.vue'
import TagStatus from './tagStatus.vue'
import { PROJECT_PLAY_STATUS } from '~/constants'

const props = defineProps<{
  data: any
}>()

const isHaveVideo = PROJECT_PLAY_STATUS.includes(
  props.data.lastGenerate?.preview_video_info?.render_video_status
)
</script>

<style lang="scss" scoped>
.preview {
  @apply absolute z-[1] right-[0] w-[28px] h-[28px] rounded-[50%] flex-center text-primary text-[16px];

  background: $action-icon-bg;
  color: white;

  &:hover {
    background: $action-icon-bg-hover;
  }
}
</style>
